
<template>
  <v-container fluid>
    <v-row class="noscroll">
      <v-col
        md="9"
        style="
          width: 100vw;
          height: 100vh;
          background-position-x: 20%;
          background-position-y: 20%;
          background-repeat: no-repeat;
          background-attachment: fixed;
        "
        :style="{ backgroundImage: 'url(' + image + ')' }"
      >
        <div
          v-for="(item, index) in items"
          :key="index"
        >
          <div
            v-draggable="item.dragg"
            style="pointer-events: none"
          >
            <img
              :src="item.src"
              height="30"
            >
            <span style="backgroundColor:#f3f4f7 ; max-width: 140px ; font-size:16px;font-weight:bold">{{ item.text }}</span>
          </div>
        </div>
      </v-col>
      <v-col md="3">
        <v-col cols="12">
          <v-select
            v-model="fieldListValue"
            :items="fieldList"
            label="選擇場域"
            solo
            @input="fieldChangeAna"
          />
        </v-col>
        <v-col cols="12">
          <v-select
            v-model="didListValue"
            :items="didList"
            label="設備編號"
            solo
            @input="didChange"
          />
        </v-col>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";

import { Draggable } from "draggable-vue-directive";
import Cookies from "js-cookie";

export default {
  directives: {
    Draggable,
  },
  components: {},
  data() {
    return {
       time: null,
      draggableValuearray: [],
      draggableValue: {
        onDragEnd: this.onPosChanged,
        initialPosition: { left: 345, top: 511 },
        resetInitialPos: false,
        draggable: false,
      },
      image: "demobg.jpg",
      files: [],
      items: [],
      initobj: {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        src: "device.png",
        id: "",
      },
      fieldList: [],
      fieldListValue: "測試用",
      deviceList: ["ALL"],
      fieldSensorList: [],
      fieldSensorValue: "",
      didListValue: "ALL",
      didList: [],
      filterDevice: {},
    };
  },
  computed: {
    host() {
      return this.$store.state.host;
    },
    loginInfo() {
      return this.$store.state.loginInfo;
    },
    loginUID() {
      return this.$store.state.loginUID;
    },
    exec_cust_gateway_000() {
      return this.$store.state.exec_cust_gateway_000;
    },
  },
  mounted: function () {
    Cookies.set("url", "/Dashboard");
    this.items = [];
    let nform = {
      cust_id: this.loginInfo.cust_id,
    };
    this.fieldList = [];
    this.$store
      .dispatch("exec_cust_gateway_000", nform)
      .then((res) => {
        if (this.loginUID.superuser == "0") {
          nform = {
            cust_id: this.loginInfo.cust_id,
            uid: this.loginInfo.uid,
          };

          this.$store
            .dispatch("exec_uid_gateway_000", nform)
            .then((res) => {
              if (res != null && res.length > 0) {
                for (var i = 0; i < res.length; i++) {
                  let gw_no = res[i].gw_no;

                  for (var j = 0; j < this.exec_cust_gateway_000.length; j++) {
                    let item = this.exec_cust_gateway_000[j];

                    if (gw_no == item.ip_adrs) {
                      this.fieldList.push(item.gw_desc);
                    }
                  }
                }

                if (this.fieldList != null && this.fieldList.length > 0) {
                  this.fieldListValue = this.fieldList[0];
                }
                this.fieldChangeAna(this.fieldListValue);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.fieldList = this.exec_cust_gateway_000.map(function (item) {
            return item.gw_desc;
          });

          if (this.fieldList != null && this.fieldList.length > 0) {
            this.fieldListValue = this.fieldList[0];
          }

          this.fieldChangeAna(this.fieldListValue);
        }
      })
      .catch((err) => {
        console.log(err);
      });

       this.time = setInterval(() => {
      this.fieldChangeAna(this.fieldListValue);
    }, 600 * 1000);
  },
  unmounted() {
    if (this.time) {
      clearInterval(this.time);
    }
  },
  methods: {
    onPosChanged: function (positionDiff, absolutePosition, event) {
      console.log("left corner", absolutePosition.left);
      console.log("top corner", absolutePosition.top);
    },
    checkSensorBtn(row, index) {
      if (row.value) {
        let obj = Object.assign({}, this.initobj);
        let dragg = Object.assign({}, this.draggableValue);
        obj.id = row.val;
        obj.text = row.c_val_name + "(" + row.val + ")";
        if (row.obj_x == 0) {
          row.obj_x = 300;
        }
        obj.c_val_name = row.c_val_name;

        if (row.obj_y == 0) {
          row.obj_y = 300;
        }

        dragg.initialPosition = {
          left: Number(row.obj_x),
          top: Number(row.obj_y),
        };
        dragg.resetInitialPos = false;
        obj.dragg = dragg;

        if (row.src != "") {
          obj.src = row.src;
        }

        this.items.push(obj);
      } else {
        this.items = this.items.filter(function (obj) {
          return obj.id !== row.val;
        });
      }
    },
    removeDuplicates(myArr, prop) {
      return myArr.filter((obj, pos, arr) => {
        return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
      });
    },
    onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
    },
    fieldChangeAna(val) {
      if (
        this.exec_cust_gateway_000 != null &&
        this.exec_cust_gateway_000.length > 0
      ) {
        this.filterDevice = this.exec_cust_gateway_000.filter(function (
          item,
          index,
          array
        ) {
          return item.gw_desc == val;
        });

        if (this.filterDevice != null && this.filterDevice.length > 0) {
          this.didChange(this.didListValue);
          let nform = {
            cond: this.filterDevice[0].ip_adrs,
          };
          this.items = [];
          this.$store
            .dispatch("exec_equip_valname_000", nform)
            .then((res) => {
              if (res != null && res.length > 0) {
                this.didList = res.map(function (item) {
                  return item.did;
                });

                this.didList = this.didList.filter(this.onlyUnique);
                this.didList.unshift("ALL");
              }
            })
            .catch((err) => {
              console.log(err);
            });

          nform = {
            ip_adrs: this.filterDevice[0].ip_adrs,
          };

          this.$store
            .dispatch("exec_cust_gateway_001", nform)
            .then((res) => {
              // console.log(res);

              if (res != null && res.length > 0) {
                let img = res[0].layout_pic;
                this.image = this.host + "/images/" + img;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    didChange(val) {
    //  let vall = val + " ";

    let vall = val + " ";
      if (val == "ALL") {
        vall = "ALL";
      }


      this.items = [];
      let nform = {
        cond: this.filterDevice[0].ip_adrs,
        did: vall,
      };
      let that = this;
      this.fieldSensorList = [];
      this.$store
        .dispatch("exec_device_now_v2_000", nform)
        .then((res) => {
          if (res != null && res.length > 0) {
            this.fieldSensorList = res.map(function (item) {
              //  console.log(item);
              let value = false;
              if (item.obj_x != 0 && item.obj_y != 0) {
                value = true;
              }

              item.val_icon = that.host + "/php/" + item.val_icon;

              let obj = {
                val_name: item.c_val_name + "(" + item.val_name + ")",
                key: item.ip_adrs + " " + item.dat,
                value: value,
                val: item.c_val_name,
                obj_x: item.obj_x,
                obj_y: item.obj_y,
                c_val_name: item.c_val_name,
                val: item.value,
                src: item.val_icon,
              };

              if (item.obj_x != 0 && item.obj_y != 0) {
                that.checkSensorBtn(obj, 1);
              }

              return obj;
            });

            this.removeDuplicates(this.fieldSensorList, "key");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style>
.chart {
  width: 300px;
  margin-right: 10px;
  float: left;
  height: 300px;
}

.inner-text {
  width: 100%;
  height: 100%;
}

.inner-text--3 {
  display: flex;
  justify-content: center;
  margin-top: 85px;
  font-size: 20px;
  color: #de3a21;
  font-weight: 700;
}
</style>